"use client";

import type { GeoTemplate, GeoTemplateProps } from "./GeoBlockSlot";
import type { ComponentType } from "react";

import * as m from "motion/react-m";
import dynamic from "next/dynamic";

const BlockLogoGrid = dynamic(() =>
  import("@/app/_blocks/BlockLogoGrid").then(mod => mod.BlockLogoGrid as unknown as ComponentType<GeoTemplateProps>),
);

// Client-side map uses dynamic imports for code splitting —
// the server-side registry in geoBlockRegistry.ts uses static imports.
const GEO_CLIENT_MAP: Record<string, ComponentType<GeoTemplateProps>> = {
  "logo-grid-block": BlockLogoGrid,
};

type GeoRegistryProps = {
  blockType: GeoTemplate;
  resolvedProps: GeoTemplateProps | null;
  defaultProps: GeoTemplateProps | undefined;
};

const fadeTransition = { duration: 0.3, ease: "easeInOut" as const };

export function GeoRegistry({ blockType, resolvedProps }: GeoRegistryProps) {
  const Component = GEO_CLIENT_MAP[blockType];
  if (!Component || !resolvedProps) return null;

  return (
    <m.div data-geo-resolved initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={fadeTransition}>
      <Component {...resolvedProps} />
    </m.div>
  );
}
